import { types } from './pbatendimento.actions'
import { Reducer } from '../../../services/reducer.factory'

const initialState = {
  id: 'pbatendimento',
  columns: [],
  currentRecord: {
    oid: '',
    nomeResponsavel: '',
    nomeFalecido: '',
    foneResponsavel: '',
  },
  messages: null,
  usaListDto: false,
}

const reducer = new Reducer(initialState, types)

export function CRUDPbAtendimentoReducer(state, action) {
  if (state) {
    state.messages = {}
  }
  state = reducer.execute(state, action)
  return execute(state, action)
}

function execute(state, action) {
  let result = state
  switch (action.type) {
    case types.RESET_FORM:
      return resetForm(state, action)
    default:
      return result
  }
}

function resetForm(state, action) {
  let booleanFilter = Object.assign({}, state.booleanFilter)
  booleanFilter[action.field] = action.value
  return Object.assign({}, state, { currentRecord: initialState.currentRecord })
}
